module.exports = __webpack_public_path__ + "static/media/webmoney.6be1746d.svg";